var map = {
	"./Clock.png": 5248,
	"./MonsterSlayer.png": 288,
	"./TicTacToe.png": 6420,
	"./TodoApp.png": 2728,
	"./calculator.png": 1180,
	"./maze.png": 5500,
	"./weather.png": 6256
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7215;